import { useMemo } from 'react'
import {
  AVATAR_BADGE_SIZE,
  AvatarBasic,
  COLOR,
} from '@npco/zeller-design-system'
import { useField } from 'formik'

export const useBpayToItem = () => {
  const [{ value: referenceValue }] = useField({
    name: 'reference',
  })
  const [{ value: contactValue }] = useField({
    name: 'to',
  })

  const selectedToContact = useMemo(() => {
    const contactItem = {
      label: contactValue?.name ?? '',
      subLabel: '',
      value: contactValue?.name ?? '',
      id: contactValue?.id ?? '',
    }

    return referenceValue || contactItem
  }, [referenceValue, contactValue])

  return {
    ...selectedToContact,
    image: (
      <AvatarBasic
        badgeSize={AVATAR_BADGE_SIZE.SMALL}
        text={selectedToContact.label}
        bgColor={COLOR.GREY_90}
      />
    ),
  }
}
